// Generated by CoffeeScript 2.7.0
var Admin__Settings__BasicController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsBasic from 'trunks/vue/admin/components/settings/settings_container/settings_basic.js';

export default Admin__Settings__BasicController = (function() {
  class Admin__Settings__BasicController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/basic.json', {
        success: function(data) {
          return new SettingsBasic({
            el: DomMaster.find("#js-settings-basic").node,
            propsData: {
              activeTab: 'basic',
              settingsData: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__BasicController.include(GenerateMorePopover);

  Admin__Settings__BasicController.include(SettingsNavigator);

  return Admin__Settings__BasicController;

}).call(this);
